<template>
    <div class="tw:max-w-2xl tw:mx-auto">
        <!-- Main Card -->
        <CardFront top-bar>
            <!-- Header -->
            <template #header>
                <div class="tw:pb-4 tw:border-b tw:border-gray-200">
                    <h1 class="tw:text-2xl tw:font-bold tw:text-gray-900 tw:text-center tw:uppercase">
                        {{ $t(esMembresia ? 'eventos.encontrado_membresia' : 'eventos.encontrado_abono', { simpatizante: textoSimpatizante }) }}!
                    </h1>
                    <p class="tw:text-base tw:text-gray-600 tw:text-center tw:mt-2">
                        {{ $t('eventos.descripcion_encontrado') }}
                    </p>
                </div>
            </template>

            <div class="tw:flex tw:flex-col tw:gap-6">
                <!-- Success Icon -->
                <div class="tw:flex tw:flex-col tw:items-center tw:text-center">
                    <div class="tw:w-16 tw:h-16 tw:bg-emerald-100 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:mb-4">
                        <svg class="tw:w-8 tw:h-8 tw:text-emerald-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </div>
                    <h2 class="tw:text-lg tw:font-bold tw:text-gray-900">
                        {{ $t(esMembresia ? 'eventos.vinculado_correctamente_membresia' : 'eventos.vinculado_correctamente_abono', { simpatizante: textoSimpatizante }) }}
                    </h2>
                    <p class="tw:text-sm tw:text-gray-500 tw:mt-1">
                        {{ $t('eventos.gestion_cuenta') }}
                    </p>
                </div>

                <!-- Datos del Titular -->
                <DatosTitular
                    :display-name="displayName"
                    :display-identification="displayIdentification"
                    :bound-email="boundEmail"
                    :display-address="displayAddress"
                />

                <!-- Info Box -->
                <InfoVinculacion :bound-email="boundEmail" :entitlement-type="entitlementType" />
            </div>

            <!-- Footer -->
            <template #footer>
                <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:pt-4 tw:border-t tw:border-gray-200">
                    <Button as="router-link" to="/perfil" custom-class="tw:w-full sm:tw:w-auto" variant="dark">
                        <svg class="tw:w-4 tw:h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                        </svg>
                        {{ $t('eventos.ir_perfil') }}
                    </Button>
                </div>
            </template>
        </CardFront>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import DatosTitular from './DatosTitular.vue';
    import InfoVinculacion from './InfoVinculacion.vue';
    import store from '@/store';

    const teatro = computed(() => store.getters.getTeatro || {});
    const textoSimpatizante = computed(() => teatro.value.texto_simpatizante || '');

    const props = defineProps({
        displayName: {
            type: String,
            default: ''
        },
        displayIdentification: {
            type: String,
            default: ''
        },
        displayAddress: {
            type: String,
            default: ''
        },
        entitlementType: {
            type: String,
            default: 'abono'
        },
        boundEmail: {
            type: String,
            default: ''
        }
    });

    const esMembresia = computed(() => props.entitlementType === 'membresia');
</script>
